import { stripFunnelPrefix } from '../../../base/app/composables/useFunnelPrefix';

export const AO_ENTRY_CAPTURED = 'aoEntryCaptured';
export const AO_ENTRY_SEARCH = 'aoEntrySearch';
export const AO_ENTRY_PATH = 'aoEntryPath';

const HOME_PATHNAME_RE = /^\/([a-z]{2}(-[a-z]{2})?)?$/i;

function normalizePathname(path: string): string {
  const p = path.endsWith('/')
    ? path.slice(0, -1)
    : path;
  return p === '' ? '/' : p;
}

export function captureEntryContextOnce(): void {
  if (!import.meta.client) {
    return;
  }
  try {
    if (!sessionStorage.getItem(AO_ENTRY_CAPTURED)) {
      sessionStorage.setItem(AO_ENTRY_CAPTURED, '1');
      sessionStorage.setItem(AO_ENTRY_SEARCH, globalThis.location.search || '');
      sessionStorage.setItem(AO_ENTRY_PATH, globalThis.location.pathname || '');
    }
  } catch {
    // ignore private mode / quota
  }
}

export function getEntrySearchForAttribution(): string {
  if (!import.meta.client) {
    return '';
  }
  try {
    if (sessionStorage.getItem(AO_ENTRY_CAPTURED) === '1') {
      return sessionStorage.getItem(AO_ENTRY_SEARCH) ?? '';
    }
  } catch {
    /* ignore */
  }
  return globalThis.location.search || '';
}

export function getEntryPathname(): string {
  if (!import.meta.client) {
    return '';
  }
  try {
    if (sessionStorage.getItem(AO_ENTRY_CAPTURED) === '1') {
      return sessionStorage.getItem(AO_ENTRY_PATH) || '';
    }
  } catch {
    /* ignore */
  }
  return globalThis.location.pathname || '';
}

export function isQuizStartPath(path: string, funnelPrefix: string): boolean {
  const withoutFunnel = stripFunnelPrefix(normalizePathname(path), funnelPrefix);

  return HOME_PATHNAME_RE.test(normalizePathname(withoutFunnel));
}

export function entryPathWasQuizStartPage(funnelPrefix: string): boolean {
  const path = getEntryPathname() || (import.meta.client ? globalThis.location.pathname : '');

  return isQuizStartPath(path, funnelPrefix);
}

export function entryQueryParams(): URLSearchParams {
  const raw = getEntrySearchForAttribution();
  const q = raw.startsWith('?') ? raw.slice(1) : raw;
  return new URLSearchParams(q);
}
